import { queryOptions } from '@tanstack/react-query';

import { api, unwrap } from '@/shared/api/client';
import { STALE } from '@/shared/api/stale';

export const sessionKeys = {
  all: ['session'] as const,
};

export const sessionQuery = queryOptions({
  queryKey: sessionKeys.all,
  queryFn: ({ signal }) => unwrap(api.GET('/session', { signal })),
  staleTime: STALE.session,
  retry: false,
});
